<template>
  <el-menu
    :default-active="activePath"
    class="sidebar-elmenu"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
    router
  >
    <el-menu-item index="/dashboard">
      <i class="el-icon-s-home"></i>
      <span>数据大盘</span>
    </el-menu-item>

    <el-submenu index="1">
  <template slot="title">
    <i class="el-icon-s-tools"></i>
    <span>系统管理</span>
  </template>
  <el-menu-item index="/system/admin">后台账号管理</el-menu-item>
  <el-menu-item index="/system/config">系统配置</el-menu-item>
  <el-menu-item index="/system/log">操作日志</el-menu-item>
</el-submenu>


    <el-submenu index="2">
      <template slot="title">
        <i class="el-icon-user"></i>
        <span>业主商户</span>
      </template>
      <el-menu-item index="/owner/list">业主&支付子商户</el-menu-item>
    </el-submenu>

    <el-submenu index="3">
      <template slot="title">
        <i class="el-icon-picture"></i>
        <span>广告管理</span>
      </template>
      <el-menu-item index="/banner/list">轮播广告</el-menu-item>
    </el-submenu>

    <el-submenu index="4">
      <template slot="title">
        <i class="el-icon-house"></i>
        <span>房源房间</span>
      </template>
      <el-menu-item index="/house/list">房源管理</el-menu-item>
      <el-menu-item index="/room/list">房间管理/审核</el-menu-item>
    </el-submenu>

    <el-submenu index="5">
      <template slot="title">
        <i class="el-icon-document"></i>
        <span>合同账单</span>
      </template>
      <el-menu-item index="/contract/list">全部合同</el-menu-item>
      <el-menu-item index="/bill/list">账单审核导出</el-menu-item>
    </el-submenu>

    <el-submenu index="6">
      <template slot="title">
        <i class="el-icon-user-solid"></i>
        <span>小程序用户</span>
      </template>
      <el-menu-item index="/wxuser/list">租客列表</el-menu-item>
    </el-submenu>

    <el-submenu index="7">
      <template slot="title">
        <i class="el-icon-wrench"></i>
        <span>报修工单</span>
      </template>
      <el-menu-item index="/repair/list">全部工单</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  computed: {
    activePath() {
      return this.$route.path
    }
  }
}
</script>
<style scoped>
.sidebar-elmenu {
  height: 100%;
  border-right: none;
}
</style>
